import { useQuery } from "react-query";
import { useEffect, useRef, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

// helpers
import { goAxiosInstance } from "helpers/axiosInstance";
import { getImgWithLogo } from "helpers/getCloudinaryImage";

// customHooks
import useCheckEndsReached from "customHooks/useCheckEndsReached";

// style
import "./styles.scss";
import { useOnClickOutside } from "customHooks/useOnClickOutside";
import capitalizeFirstLetter from "helpers/cap";

export const DrawerCollection = ({ handleDrawer, showDrawer }: any) => {
	const [close, setClose] = useState(true);

	const divRef = useRef(null);
	// useOnClickOutside(divRef, () => handleDrawer(false));

	const homeCollection = useQuery(["home_page_collection"], () => {
		return goAxiosInstance({
			method: "GET",
			url: "/home-collections",
		});
	});

	const data = homeCollection?.data?.data?.data;

	useEffect(() => {
		if (!close) {
			setTimeout(() => {
				handleDrawer(false);
				setClose(true);
			}, 300);
		}
	}, [close]);

	const name =
		window.location.pathname?.split("/")[2]?.split("-")[2] !== "me" ? (
			<>
				{window.location.pathname?.split("/")[2]?.split("-")[2] ? (
					<>
						{capitalizeFirstLetter(
							window.location.pathname
								?.split("/")[2]
								?.split("-")[2]
								?.replace("%20", " "),
						)}
					</>
				) : (
					""
				)}
			</>
		) : (
			"Near Me"
		);

	return (
		<div className="collection__wrapper">
			<div className="close" onClick={() => setClose(false)}>
				Close
			</div>
			<div
				className={`drawer__collection__container drawer__collection${
					showDrawer && close ? "__active" : "__notactive"
				}`}
				ref={divRef}
			>
				<h2>Collections for {name}</h2>
				<div className="card__container">
					{data?.map((data: any, i: number) => {
						const src =
							data.HOME_COVER_IMAGE !== ""
								? getImgWithLogo({
										id: data.HOME_COVER_IMAGE,
										version: "1636374075",
										quality: "80",
										height: "507",
										width: "500",
								  })
								: "";
						return (
							<a
								className="card"
								href={`/collection/${data.SLUG}`}
								target="_blank"
								rel="noreferrer"
								key={i}
							>
								<span>
									<LazyLoadImage src={src} alt={data.TITLE} effect="blur" />
								</span>
								<div className="title__container">{data.TITLE}</div>
							</a>
						);
					})}
				</div>
			</div>
		</div>
	);
};
